import React from 'react';
import { connect } from 'react-redux';
import commonAction from '../../actions/common'
import ScrollBox from '../../components/ScrollBox'
import Lodding from '../../components/Lodding'
import NoData from '../../components/NoData'
import { getSalaryMonthItemDetail } from '../../api/Salary'
import { formatSalaryAmount, salaryDetailTypeMap } from '../../libs/salary'
import './index.scss'

class SalaryItemDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      isCanLoading: true,
      scrollHight: 0,
      animating: false,
      detailTypeName: ''
    }
    this.pageIndex = 1
    this.pageSize = 20
    this.total = 0
  }

  componentDidMount() {
    const pathname = this.props.path;
    this.props.dispatch({ type: commonAction.setPathname, pathname })
    this.props.onRef(this);
    const detailType = Number(this.props.match.params.detailType)
    this.setState({
      detailTypeName: salaryDetailTypeMap[detailType] || '费用项明细'
    }, () => {
      this.handleRefresh()
    })
  }

  getSalaryMonthItemDetailFun = async () => {
    this.setState({
      animating: true
    })
    const res = await getSalaryMonthItemDetail({
      settlementMonth: this.props.match.params.month,
      detailType: Number(this.props.match.params.detailType),
      pageIndex: this.pageIndex,
      pageSize: this.pageSize
    })
    if (res.code === 200 && res.data) {
      const list = res.data.list || []
      this.total = res.data.total || 0
      let detailTypeName = this.state.detailTypeName
      if (list.length && list[0].detailTypeName) {
        detailTypeName = list[0].detailTypeName
      }
      this.setState((state) => ({
        list: state.list.concat(list),
        isCanLoading: true,
        detailTypeName
      }))
    }
    this.setState({
      animating: false
    })
  }

  handleScroll = () => {
    this.setState({
      isCanLoading: false
    })
    if (this.state.list.length < this.total) {
      this.pageIndex += 1
      this.getSalaryMonthItemDetailFun()
      return
    }
    this.setState({
      isCanLoading: true
    })
  }

  handleRefresh = () => {
    this.pageIndex = 1
    this.total = 0
    this.setState({
      list: [],
      scrollHight: 0
    }, () => {
      this.getSalaryMonthItemDetailFun()
    })
  }

  setScrollHight = (val) => {
    this.setState({
      scrollHight: val
    })
  }

  renderField(label, value) {
    return (
      <div className="salaryItemDetailBox-item-row">
        <span>{label}</span>
        <p>{value || '--'}</p>
      </div>
    )
  }

  render() {
    return (
      <div className="salaryItemDetailBox commonBodyBox">
        <div className="salaryItemDetailBox-scroll">
          {this.state.list.length ? (
            <ScrollBox
              setScrollHight={this.setScrollHight}
              handleRefresh={this.handleRefresh}
              scrollHight={this.state.scrollHight}
              handleScroll={this.handleScroll}
              isCanLoading={this.state.isCanLoading}
            >
              <div className="salaryItemDetailBox-main">
                <div className="salaryItemDetailBox-summary">
                  <h3>{this.state.detailTypeName}</h3>
                  <p>{this.props.match.params.month}</p>
                </div>
                {this.state.list.map((item) => (
                  <div className="salaryItemDetailBox-item" key={item.id}>
                    {this.renderField('工单编号', item.sourceNo)}
                    {this.renderField('项目', item.projectName)}
                    {this.renderField('电梯位置', item.liftLocation)}
                    {this.renderField('使用证编号', item.useCertificateNumber)}
                    {this.renderField('任务/扣分项', item.taskName)}
                    {this.renderField('完成时间', item.completeTime)}
                    <div className="salaryItemDetailBox-item-row is-amount">
                      <span>金额</span>
                      <strong>{formatSalaryAmount(item.amount)}</strong>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollBox>
          ) : <NoData />}
        </div>
        <Lodding animating={this.state.animating} />
      </div>
    )
  }
}

export default connect()(SalaryItemDetail);
